<template>
  <div class="d-flex justify-content-center align-items-center w-100 h-100">
    <div class="font-size-h2 text-header-color text-center px-4">KIOSK IS CURRENTLY NOT AVAILABLE.</div>
  </div>
</template>

<script>
export default {
  name: 'KioskDisabled'
}
</script>
